import React from 'react';
import styles from '../FeedbackPage.module.css';

const ProgressBar = ({ progressPercentage }) => (
  <div className={styles.progressContainer}>
    <div className={styles.progressBar} style={{ width: `${progressPercentage}%` }}></div>
    <span className={styles.progressText}>{Math.round(progressPercentage)}% completed</span>
  </div>
);

export default ProgressBar;
